if (typeof GenericAlerts === 'undefined') {
  class GenericAlerts extends HTMLElement {
    constructor() {
      super()
    }
  }

  /**
   * @param {string} type - "Info", "Success", "Warning", "Error"
   * @param {string} text - String of Text to be displayed
   * @param {boolean} reload - True or False to Reload Page
   */

  function sendNotification(type, text, reload) {
      const notificationBox = document.querySelector(".notification-box");
      function svg(path) {
        return `<svg class="w-50 h-50 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">${path}</svg>`
      }
      const alerts = {
        info: {
          icon: svg(`<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />`),
          color: "blue-500"
        },
        error: {
          icon: svg(`<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />`),
          color: "red-500"
        },
        warning: {
          icon: svg(`<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />`),
          color: "yellow-500"
        },
        success: {
          icon: svg(`<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />`),
          color: "green-500"
        }
      };
      const alert = document.createElement("div");
      alert.className = `relative flex items-center bg-${alerts[type].color} text-white text-sm font-bold p-16 rounded-[8px] opacity-0 transform transition-all duration-500 mb-1`;
      alert.innerHTML += `<button id="close-alert" class="close absolute top-[8px] right-[10px]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-22 h-22">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                              ${alerts[type].icon}<p class="p-16">${text}</p>`;
      notificationBox.appendChild(alert);

      function _reload() {
        window.location.reload()
      }

      const close = document.getElementById("close-alert")
      function _closeAlert() {
        notificationBox.removeChild(alert);
        reload ? _reload() : null // if we want to force a reload on alert close
      }
      close.addEventListener("click", _closeAlert)

      setTimeout(() => {
        alert.classList.remove("opacity-0");
        alert.classList.add("opacity-1");
      }, 1); //1ms For fixing opacity on new element

      // Setting default timeout for UX purposes to remove the element
      // versus user click to close
      setTimeout(() => {
        alert.classList.remove("opacity-1");
        alert.classList.add("opacity-0");
        alert.style.margin = 0;
        alert.style.padding = 0;
      }, 4500);
      setTimeout(() => {
        alert.style.setProperty("height", "0", "important");
      }, 4750);
      setTimeout(() => {
        notificationBox.removeChild(alert);
        reload ? _reload() : null // if we want to force a reload
      }, 5000);
    }

  if (customElements.get('generic-alerts') === undefined) {
    customElements.define('generic-alerts', GenericAlerts)
  }
}
